export default __webpack_public_path__ + "static/media/trovityAssistancecimage.08a479d6.svg";